import { IOpcaoTela } from '../permissionScreen/permissionScreen.types';
import { ITela } from './currentScreen.types';

export function validarTelaAtual(tela: ITela): IOpcaoTela | null {
  const telaAtual = converterTelaAtual(tela);
  return telaAtual;
}

function converterTelaAtual(tela: ITela): IOpcaoTela | null {
  const telaMap: Record<ITela, IOpcaoTela> = {
    '/listagem/agendamento': 'listaAgendamento',
    '/listagem/parametrizacao': 'parametrizacaoPatio',
    '/listagem/funcionario': 'listaFuncionario',
    '/listagem/empresa': 'listaEmpresa',
    '/listagem/empresa/transferencia': 'transferenciaEmpresaFrota',
    '/listagem/blacklist': 'listaBlackList',
    '/listagem/servico': 'parametrizacaoServico',
    '/listagem/servicos': 'listaServico',
    '/listagem/precificacao': 'parametrizacaoPreco',
    '/listagem/entrada-gate': 'listaGateEntrada',
    '/listagem/laudos-higienizacao': 'listaLaudoHigienizacao',
    '/listagem/desengates': 'listaDesengate',
    '/listagem/engates': 'listaEngate',
    '/listagem/estacionamento-tpg': 'listaTampa',
    '/listagem/saida-gate': 'listaGateSaida',
    '/listagem/caixa': 'cadastrarAberturaCaixa',
    '/cadastro/agendamento': 'listaAgendamento',
    '/cadastro/parametrizacao': 'parametrizacaoPatio',
    '/cadastro/funcionario': 'cadastrarFuncionario',
    '/cadastro/servico': 'parametrizacaoServico',
    '/cadastro/precificacao': 'parametrizacaoPreco',
    '/cadastro/entrada': 'cadastrarGateEntrada',
    '/cadastro/servicos': 'cadastrarServico',
    '/cadastro/laudo-higienizacao': 'cadastrarLaudoHigienizacao',
    '/cadastro/desengate': 'cadastrarDesengate',
    '/cadastro/engate': 'cadastrarEngate',
    '/cadastro/entrada-estacionamento-tpg': 'cadastrarEntradaTampa',
    '/cadastro/saida-estacionamento-tpg': 'cadastrarSaidaTampa',
    '/cadastro/saida-gate': 'cadastrarGateSaida',
    '/cadastro/caixa': 'cadastrarAberturaCaixa',
    '/parametrizacao/servico': 'parametrizacaoServico',
    '/parametrizacao/precificacao': 'parametrizacaoPreco',
    '/parametrizacao/patio': 'parametrizacaoPatio',
    '/cadastro/higienizacao-agendada': 'higienizacaoAgendada',
    '/listagem/higienizacao-agendada': 'higienizacaoAgendada',
    '/listagem/estoque/produtos': 'listaProduto',
    '/listagem/estoque': 'listaEstoque',
    '/listagem/estoque/inventario': 'listaInventario',
    '/listagem/estoque/movimentacoes': 'listaMovimentacoesEstoque',
    '/listagem/estoque/dashboard': 'graficoEstoqueIndicadores',
    '/listagem/estoque/relatorio-estoque': 'relatorioVendasEstoque',
    '/listagem/estoque/relatorio-vendas': 'relatorioVendasEstoque',
    '/listagem/estoque/relatorio-movimentacoes': 'listaMovimentacoesEstoque',
    '/listagem/estoque/relatorio-posicao': 'relatorioPosicaoEstoque',
    '/listagem/caixa-estoque': 'caixaEstoque',
    '/cadastro/estoque/produto': 'cadastrarProduto',
    '/cadastro/estoque/entrada': 'cadastrarEntradaEstoque',
    '/cadastro/estoque/saida': 'cadastrarSaidaEstoque',
    '/cadastro/estoque/ajuste': 'cadastrarAjusteEstoque',
    '/listagem/relatorios/dashboard-servicos': 'graficoLimpezasPorMes',
    '/listagem/relatorios/dashboard-patio': 'graficoPatioTotalVeiculos',
    '/listagem/relatorios/dashboard-financeiro': 'dashboardFinanceiro',
    '/listagem/relatorios/relatorio-veiculos': 'relatorioVeiculos',
    '/listagem/relatorios/historico-veiculo': 'historicoVeiculo',
    '/listagem/relatorios/laudos-editados': 'laudosEditados',
    '/listagem/relatorios/laudos-servico': 'financeiroMlServicos',
    '/listagem/relatorios/financeiro-patio': 'financeiroPatio',
    '/listagem/relatorios/vendas-por-produto': 'vendasPorProduto',
    '/listagem/relatorios/laudos-excluidos-cancelados': 'laudosExcluidosCancelados',
    '/listagem/relatorios/relatorios-gerais': 'relatorioTerminal',
    '/listagem/relatorios/relatorio-terminal': 'relatorioTerminal',
    '/listagem/relatorios/relatorio-terminal-laudos': 'relatorioTerminalPdf',
    '/listagem/relatorios/relatorio-carregamento-quantitativo': 'relatorioCarregamentoQuantitativo',
    '/listagem/relatorios/relatorio-carregamento-detalhado': 'relatorioCarregamentoDetalhado',
    '/listagem/relatorios/relatorio-cliente-quantitativo': 'relatorioClienteQuantitativo',
    '/listagem/relatorios/relatorio-cliente-detalhado': 'relatorioClienteDetalhado',
    '/listagem/relatorios/relatorio-mensal-laudos': 'relatorioMensalLaudos',
    '/listagem/relatorios/relatorio-quantidade-cliente-laudos': 'relatorioQuantidadeClienteLaudos',
    '/listagem/relatorios/relatorio-placas-caixa': 'relatorioPlacasCaixa',
    '/listagem/relatorios/relatorio-clientes-caixa': 'relatorioClientesCaixa',
    '/listagem/relatorios/historico-alteracoes': 'listaLogs'
  };

  return telaMap[tela] ?? null;
}
